import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Draggable, DropBin } from '@/components';

interface GrabGameRootWordsProps {
  word: string;
  suffix: string;
  wordChoices: Array<string>;
}

export const GrabGameRootWords = ({
  word,
  suffix,
  wordChoices,
}: GrabGameRootWordsProps) => {
  const [value, setValue] = useState<string | undefined>(undefined);
  const [isCorrect, setIsCorrect] = useState(false);

  useEffect(() => {
    if (!value) {
      setIsCorrect(false);

      return;
    }

    setIsCorrect(`${value}${suffix}` === `${word}${suffix}`);
  }, [value, word, suffix]);

  return (
    <div className="flex flex-col gap-6 justify-center items-center h-full pl-6 pb-24">
      <div className="flex gap-2 justify-center">
        <DropBin
          className={clsx(
            'h-24 min-w-36 px-2 font-sassoonInfant text-8xl text-left',
            !value
              ? 'bg-white text-black'
              : isCorrect
                ? 'bg-[var(--c-success)] text-white'
                : 'bg-[var(--c-select)] text-white',
          )}
          value={value}
          setValue={setValue}
          showValue
        />

        <h2 className="text-8xl font-sassoonInfant">{suffix}</h2>
      </div>

      <div className="flex gap-6 justify-center">
        {wordChoices.map((wordChoice, index) => (
          <Draggable
            key={index}
            className="h-24 px-6 bg-white rounded-xl text-8xl font-sassoonInfant"
            value={wordChoice}
          >
            {wordChoice}
          </Draggable>
        ))}
      </div>
    </div>
  );
};
